module.exports = __webpack_public_path__ + "img/motor_no74.76557635.jpg";